import { render } from "./CreateLeadModal.vue?vue&type=template&id=0877230a&scoped=true&ts=true&lang=pug"
import script from "./CreateLeadModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateLeadModal.vue?vue&type=script&lang=ts&setup=true"

import "./CreateLeadModal.vue?vue&type=style&index=0&id=0877230a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0877230a"]])

export default __exports__